import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatText',
    standalone: false
})
export class FormatTextPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.replace(/_/g, ' ');
  }
}
